import { stats } from '@/mocks/data';

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat) => (
          <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
            <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
              <i className={`${stat.displayIcon || stat.icon} text-xl text-accent-600`}></i>
            </div>
            <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{stat.value}</div>
            <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}